import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{this.subscribe @taskId}}",{ moduleName: "my-phorest/components/background-task-change-handler/index.hbs" })